var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":_vm.btnType,"icon":_vm.icon},on:{"click":function($event){return _vm.f_export()}}},[_vm._v(_vm._s(_vm.btnText))])
}
var staticRenderFns = []

export { render, staticRenderFns }